import { useEffect, useState } from 'react'

import { useI18n } from '@/lib/i18n'

export const WAITING_TIP_ROTATION_MS = 10_000

export const WAITING_TIP_I18N_KEYS = [
  'play.waitingTips.magicianSwap',
  'play.waitingTips.werewolfSelfDestruct',
  'play.waitingTips.expertMode',
  'play.waitingTips.multiplayer',
  'play.waitingTips.knightVsWolfBeauty',
  'play.waitingTips.bloodMoonBlackout',
  'play.waitingTips.bloodMoonFinalCut',
  'play.waitingTips.guardWitchConflict',
  'play.waitingTips.sheriffPowers',
  'play.waitingTips.tieBreak',
  'play.waitingTips.edgeWin',
  'play.waitingTips.poisonedHunter',
  'play.waitingTips.firstNightLastWords',
] as const

interface WaitingTipRotationController {
  stop: () => void
}

export function startWaitingTipRotation(
  onAdvance: () => void,
): WaitingTipRotationController {
  let stopped = false
  const timer = setInterval(() => {
    if (stopped)
      return
    onAdvance()
  }, WAITING_TIP_ROTATION_MS)

  return {
    stop: () => {
      if (stopped)
        return
      stopped = true
      clearInterval(timer)
    },
  }
}

export function WaitingTipsCarousel() {
  const { t } = useI18n()
  const [tipIndex, setTipIndex] = useState(0)

  useEffect(() => {
    const rotation = startWaitingTipRotation(() => {
      setTipIndex(index => (index + 1) % WAITING_TIP_I18N_KEYS.length)
    })
    return rotation.stop
  }, [])

  const tipKey = WAITING_TIP_I18N_KEYS[tipIndex]!

  return (
    <p
      key={tipIndex}
      aria-live="off"
      className="text-xs text-muted-foreground/80 duration-500 animate-in fade-in slide-in-from-bottom-1 motion-reduce:animate-none"
      data-testid="waiting-tip"
      data-tip-index={tipIndex}
    >
      {t(tipKey)}
    </p>
  )
}
